import { createTheme } from '@mantine/core';

export const theme = createTheme({
   fontFamily: 'Inter, sans-serif',
        fontSizes: {
        xs: 10,
        sm: 11,
        md: 14,
        lg: 16,
        xl: 20,
  },

  // Τα χρώματα που είδα στα CSS σου
  colors: {
    brandBlue: [
      '#eef2ff', '#e0e7ff', '#c7d2fe', '#a5b4fc', '#818cf8', 
      '#6366f1', '#4f46e5', '#3858e9', '#3730a3', '#312e81' // Το #3858e9 είναι το βασικό σου (index 7)
    ],
    brandPurple: [
      '#faf5ff', '#f3e8ff', '#e9d5ff', '#d8b4fe', '#c084fc', 
      '#a855f7', '#9333ea', '#7e22ce', '#663399', '#581c87' // Το #581c87 (rebeccapurple) (index 8)
    ],
  },
  primaryColor: 'brandBlue',
  primaryShade: 8, // Λέμε στο Mantine να χρησιμοποιεί το δικό σου ακριβές μπλε ως default
  secondaryColor: 'brandPurple',
  secondaryShade: 9, // Λέμε στο Mantine να χρησιμοποιεί το δικό σου ακριβές purple ως default
});